module.exports = __webpack_public_path__ + "static/floral 9 3000x3000-293081ab0aa90d7355613e286bbd4e86.jpg";